<template>
  <v-container
    fill-height
    class="mb-5"
  >
    <v-layout
      justify-space-between
      wrap
    >
      <v-flex
        xs12
        md5
      >
        <h2
          class="headline mb-2"
          v-text="$t('Contact.heading1')"
        />
        <p
          class="mb-4"
          v-text="$t('Contact.headingText1')"
        />
        <v-card>
          <v-card-text>
            <v-text-field
              v-model="cc.name"
              label="Name"
              prepend-icon="mdi-account"
            />
            <v-text-field
              v-model="ccemail"
              label="Email"
              prepend-icon="mdi-email"
            />
            <v-textarea
              v-model="cc.message"
              label="Message"
              prepend-icon="mdi-message-text"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              large
              class="px-5"
              color="primary"
              @click="sendContact"
            >
              {{ $t('Contact.submit') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm3
      >
        <v-card>
          <div class="pa-3">
            <v-img
              src="/static/NBinfo.png"
              alt="logo"
              class="my-3"
            />
          </div>
          <v-card-text>
            <div>
              <b>MailTo: </b><a
                :href="'mailto:' + $t('Contact.email')"
                target="_new"
                v-text="$t('Contact.email')"
              />
            </div>
            <div>
              <b>Web: </b><a
                :href="$t('Contact.web')"
                target="_new"
                v-text="$t('Contact.web')"
              />
            </div>
            <div><b>Phone: </b><span v-text="$t('Contact.phone')" /></div>

            <div class="mt-3">
              <b>Address: </b>
            </div>
            <div
              class="ml-2"
              v-text="$t('Contact.address')"
            />
            <div
              class="ml-2"
              v-text="$t('Contact.address2')"
            />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-layout justify-center>
          <div>
            <v-alert
              v-model="alert"
              dismissible
              close-text="Close"
              :type="type"
            >
              {{ infotext }}
            </v-alert>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  // const functions = require('firebase-functions')
  // import firebase from 'firebase'
  import firebase from '@/firebase/'
  export default {
    data () {
      return {
        cc: {},
        alert: false,
        type: 'info',
        infotext: ''
      }
    },
    metaInfo: {
      title: 'Contact',
      meta: [
        { name: 'description', content: 'Take contact!' }
      ]
    },
    computed: {
      // asdf () {  return { name: this.cc.name } }
      // emailref () { return 'mailto:' + this.$i18n.t('Contact.email') }
      ccemail: {
        set: function (newVal) {
          this.cc.email = newVal
          // console.log(newVal)
          // && typeof (this.cc.email) !== 'undefined'
          if ((typeof (this.cc.name) === 'undefined' || this.cc.name === '') && newVal.indexOf('@') > 0) {
            this.cc.name = newVal.split('@')[0]
          }
        },
        get: function () {
          return this.cc.email
        }
      }
    },
    methods: {
      sendContact () {
        this.alert = false
        if (this.formValid()) {
          // var sendMinMail = functions().httpsCallable('sendMinMail');
          // JSON.parse(JSON.stringify(this.cc))
          var contacts = firebase.firestore().collection('contacts')
          // var obj = Object.assign({"date": new Date()}, this.cc)
          var that = this
          contacts.add(
            Object.assign({ 'date': new Date() }, this.cc)
          ).then(function (docRef) {
            that.type = 'success'
            that.infotext = 'Thank You ' + that.cc.name + '! You will hear from us - as soon as possible'
            that.alert = true
            that.cc = {}
            console.log('Document written with ID: ', docRef.id)
          }).catch(function (error) {
            console.log('Error adding document: ', error)
            // console.error('Error adding document: ', error)
          })
        }
      },
      formValid () {
        var rv = this.isEmailValid(this.cc.email)
        rv += (typeof (this.cc.message) === 'undefined') ? 3 : 0
        if (rv === 0) {
          return true
        } else {
          switch (rv) {
            case 4:
            case 5:
              this.infotext = 'Please fill out email and write a few words about Your interests.'
              this.type = 'warning'
              break
            case 3:
              this.infotext = 'Please write a few words about Your interests.'
              this.type = 'warning'
              break
            case 1:
            case 2:
              this.infotext = 'Please fill out (valid) email.'
              this.type = 'error'
              break
            default:
              break
          }
          this.alert = true
          return false
        }
      },
      isEmailValid (email) {
        // return ''(0) OR  'has-success' (-1) OR 'has-error' (1)
        // eslint-disable-next-line
        const valid = { reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/ }
        return (email === '') ? 1 : (valid.reg.test(email)) ? 0 : 2
      }
    }
  }
</script>
